(function () {
  'use strict';

  var HEADINGS = {
    exhibitor: 'Кандидатствай като изложител',
    partner: 'Кандидатствай като партньор',
    sponsor: 'Кандидатствай като спонсор',
    speaker: 'Кандидатствай като лектор'
  };

  function track(name, params) {
    if (typeof window.gtag === 'function') window.gtag('event', name, params || {});
    if (typeof window.fbq === 'function') window.fbq('trackCustom', name, params || {});
  }

  function validate(form) {
    var firstBad = null;
    Array.prototype.forEach.call(form.querySelectorAll('[required]'), function (input) {
      var error = document.getElementById(input.id + '-error');
      var value = input.type === 'checkbox' ? (input.checked ? 'on' : '') : input.value.trim();
      var message = '';
      if (!value) message = input.type === 'checkbox' ? 'Моля, потвърди съгласието.' : 'Моля, попълни това поле.';
      else if (input.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value)) message = 'Провери имейл адреса.';
      if (error) error.textContent = message;
      input.setAttribute('aria-invalid', message ? 'true' : 'false');
      if (message && !firstBad) firstBad = input;
    });
    return firstBad;
  }

  function sendToSheet(form) {
    var holder = form.querySelector('[data-sheet-url]');
    if (!holder) return Promise.resolve();
    var body = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      if (key === 'zd_hp' || key.indexOf('contact[') === 0) body.append(key, value);
    });
    var sent = fetch(holder.getAttribute('data-sheet-url'), { method: 'POST', mode: 'no-cors', body: body, keepalive: true }).catch(function () {});
    var timeout = new Promise(function (resolve) { setTimeout(resolve, 2500); });
    return Promise.race([sent, timeout]);
  }

  function initParticipation() {
    var dialog = document.getElementById('participation-modal');
    if (!dialog) return;
    var form = dialog.closest('form');
    var title = dialog.querySelector('#participation-title');
    var types = dialog.querySelector('[data-types]');
    var stand = dialog.querySelector('[data-stand]');
    var status = dialog.querySelector('.zdr-form__status');
    var currentType = 'exhibitor';

    function setType(type) {
      currentType = type;
      title.textContent = HEADINGS[currentType];
      stand.hidden = currentType !== 'exhibitor';
      types.querySelector('[data-type="' + currentType + '"]').checked = true;
    }

    function open(type) {
      if (types) setType(type);
      if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
      track('participation_open', { participation_type: currentType });
    }

    function close() {
      if (typeof dialog.close === 'function') dialog.close(); else dialog.removeAttribute('open');
    }

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-participate]');
      if (opener) { event.preventDefault(); open(opener.getAttribute('data-participate')); return; }
      if (event.target.closest('.zdr-modal__close, .zdr-form__cancel, .zdr-modal__close-done')) { event.preventDefault(); close(); }
    });
    dialog.addEventListener('click', function (event) { if (event.target === dialog) close(); });

    if (dialog.hasAttribute('data-reopen')) {
      if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
      if (dialog.querySelector('.zdr-modal__done')) track('participation_submit', {});
    }

    if (!types) return;
    types.addEventListener('change', function (event) { setType(event.target.getAttribute('data-type')); });
    // Shopify's hCaptcha only adds its token on a real submit event, so after our checks the form is
    // re-submitted with requestSubmit() and this handler lets that second event through. The modal is
    // closed first: a captcha challenge would otherwise open underneath the top-layer <dialog>.
    form.addEventListener('submit', function (event) {
      if (form.dataset.zdReady) return;
      event.preventDefault();
      var firstBad = validate(form);
      if (firstBad) { status.textContent = 'Провери маркираните полета.'; firstBad.focus(); return; }
      status.textContent = 'Изпращаме…';
      var consent = form.querySelector('#f-consent');
      if (consent && consent.checked) track('consent_given', { participation_type: currentType });
      sendToSheet(form).then(function () {
        form.dataset.zdReady = '1';
        close();
        if (typeof form.requestSubmit === 'function') form.requestSubmit(); else HTMLFormElement.prototype.submit.call(form);
      });
    });
  }

  function initCommunity() {
    var form = document.getElementById('zd-community-form');
    if (!form) return;
    if (form.querySelector('.join__done')) {
      track('community_signup', {});
      form.scrollIntoView({ block: 'center' });
      return;
    }
    form.addEventListener('submit', function (event) {
      var firstBad = validate(form);
      if (firstBad) { event.preventDefault(); firstBad.focus(); }
    });
  }

  function initCheckout() {
    var box = document.querySelector('[data-zd-checkout]');
    if (!box) return;
    var variant = box.getAttribute('data-variant');
    var token = box.getAttribute('data-token');
    var status = box.querySelector('[data-buy-status]');
    var query = 'mutation ($lines: [CartLineInput!]!) { cartCreate(input: { lines: $lines, buyerIdentity: { countryCode: BG } }) { cart { checkoutUrl } userErrors { message } } }';

    box.addEventListener('click', function (event) {
      var button = event.target.closest('[data-buy]');
      if (!button || button.disabled) return;
      var qty = parseInt(button.getAttribute('data-buy'), 10);
      button.disabled = true;
      status.textContent = 'Отваряме плащането…';
      track('begin_checkout', { placement: button.getAttribute('data-ticket'), quantity: qty });
      fetch('/api/2025-07/graphql.json', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': token },
        body: JSON.stringify({ query: query, variables: { lines: [{ merchandiseId: variant, quantity: qty }] } })
      })
        .then(function (res) { return res.json(); })
        .then(function (json) {
          var cart = json && json.data && json.data.cartCreate && json.data.cartCreate.cart;
          if (!cart || !cart.checkoutUrl) throw new Error('no checkout');
          window.location.href = cart.checkoutUrl;
        })
        .catch(function () {
          status.textContent = box.getAttribute('data-error');
          button.disabled = false;
        });
    });
  }

  function initSpeakers() {
    var dialog = document.getElementById('speaker-modal');
    if (!dialog) return;
    var photo = dialog.querySelector('.speaker-modal__photo');

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-speaker]');
      if (!opener) return;
      var card = opener.closest('.speaker');
      var img = card.querySelector('.speaker__photo');
      photo.src = img.currentSrc || img.src;
      dialog.querySelector('.zdr-modal__title').textContent = card.querySelector('.speaker__name').textContent;
      dialog.querySelector('.speaker-modal__role').textContent = card.querySelector('.speaker__title').textContent;
      dialog.querySelector('.speaker-modal__bio').textContent = card.querySelector('.speaker__bio').textContent;
      dialog.showModal();
    });
    dialog.querySelector('.zdr-modal__close').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
  }

  function initBuyBar() {
    var bar = document.querySelector('[data-buybar]');
    if (!bar || !('IntersectionObserver' in window)) return;
    var targets = [document.querySelector('.hero__cta'), document.getElementById('tickets')].filter(Boolean);
    var visible = new Set();
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) visible.add(entry.target); else visible.delete(entry.target);
      });
      bar.hidden = visible.size > 0;
    });
    targets.forEach(function (target) { observer.observe(target); });
  }

  function initNav() {
    var toggle = document.querySelector('[data-nav-toggle]');
    var nav = document.querySelector('[data-nav]');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function () {
      var open = nav.hasAttribute('data-open');
      if (open) nav.removeAttribute('data-open'); else nav.setAttribute('data-open', '');
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
    nav.addEventListener('click', function (event) {
      if (event.target.tagName === 'A') { nav.removeAttribute('data-open'); toggle.setAttribute('aria-expanded', 'false'); }
    });
  }

  function init() {
    document.documentElement.classList.add('js');
    document.addEventListener('click', function (event) {
      var ticket = event.target.closest('a[data-ticket]');
      if (ticket) track('ticket_click', { placement: ticket.getAttribute('data-ticket') });
    });
    initNav();
    initParticipation();
    initCommunity();
    initCheckout();
    initSpeakers();
    initBuyBar();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
